import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Form } from 'react-bootstrap';
import './DlUnitEdit.scss';
import { getSer, saveSer } from "../../actions";
import FileUpload from './FileUpload';
import StatFileLink from '../StatFileLink';
import PhotoSer from '../../models/PhotoSer';
import AdmPhSerSingleNav from './AdmPhSerSingleNav';

const mapStateToProps = (state) => ({
  phSSer: state.phSer.phSSer,
});
  
const mapDispatchToProps = (dispatch) => ({
  getSer: (id) => dispatch(getSer(id)),
  saveSer: (payload) => dispatch(saveSer(payload)),
});

const AdmPhotoSerPhUpd = ({ match, getSer, saveSer, phSSer }) => {
  let [photos, photosSet] = useState([]);
  const itemId = ( 'itemId' in match.params ? match.params.itemId : '' );
  let photosStart = phSSer.photos;
  let rfDescN = [];

  useEffect(function() {
    if (itemId!=='') {
      getSer({'_id': itemId});
    }  
  }, [itemId]);

  useEffect(function() {
    photosSet(photosStart);
  }, [photosStart]);

  const saveItem = () => {
    let item = new PhotoSer();
    item.obSet(phSSer);
    item.photos = photos;
    saveSer({ itemId, item });
  };

  const phUpAfter = (res, ind) => {
    res = JSON.parse(res);
    let photos2 = photos.slice(0, ind);
    const phDesc = rfDescN[ind].current.value;
    console.log(res);
    
    for (let i = 0; i < res.files.length; i++) {
      const phName = res.files[i]['filename'];
      const phMiddle = res.files[i]['imAdd']['middle']['fNam'];
      const phSmall = res.files[i]['imAdd']['small']['fNam'];

      const ph = {
        name: phName,
        middle : phMiddle,
        small : phSmall,
        desc : phDesc,
        ord : 1,
        tag : [],
      };
      photos2.push(ph);
    }
    photos2 = photos2.concat(photos.slice(ind));
    photosSet(photos2);
  };

  const phUpOpt = {
    upFoldPath: 'up/photo-series/' + phSSer.fold + '/',
    upOnSel: true,
    multi: true,
    resizeOpt: {
      resizeType: 'w_h', 
      whMax: 1700
    },
    imAdd: {
      middle: { 
        resizeOpt: { 
            resizeType: 'w_h', 
            whMax: 400, 
            fNew: true, 
            fNewNam: '', 
            fNewNamSuf: '-s' 
        } 
      },
      small: { 
          resizeOpt: { 
              resizeType: 'w_h', 
              whMax: 150, 
              fNew: true, 
              fNewNam: '', 
              fNewNamSuf: '-m' 
          } 
      },
    },

  };

  const deleteItem = (ind) => {
    const photos2 = [...photos];
    photos2.splice(ind, 1);
    photosSet(photos2); 
  };

  const upElGet = (i) => {
    rfDescN[i] = React.createRef();
    let upEl = <div key={'up-el-' + i} style={{ marginTop: '2em'}}>
      <FileUpload fOpt={ phUpOpt } fUpAfter={ phUpAfter } fUpAfterPar={ i } />
      <Form.Control as="textarea" ref={rfDescN[i]} style={{ marginTop: '0.5em' }} />
    </div>;
    return upEl;
  };

  let upEl = upElGet(0);
  let fileUpLi = [upEl];
  for (let i = 0; i < photos.length; i++) {
    const ph = photos[i];
    const phEl = <div key={'f-el-' + i} style={{ marginLeft: '2%', marginRight: '2%', marginTop: '2em' }}>
      <StatFileLink fold={ 'photo-series/' + phSSer.fold } fNam={ ph['name'] } nam={ ph['name'] } addOpt={{ lStyle: { marginRight: '3%' }, dispType: 'im', lIm: ph['small'], lFold: 'photo-series/' + phSSer.fold }} />
      <div style={{ maxWidth: '35%' }}>{ ph.desc }</div>
      <span onClick={() => deleteItem(i)} style={{ cursor: 'pointer', marginRight: '5%' }} >x</span>
    </div>;
    upEl = upElGet(i + 1);
    fileUpLi.push(phEl);
    fileUpLi.push(upEl);    
  }

  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
    >
      <AdmPhSerSingleNav item={ phSSer } />
      <Row style={{ marginTop: '1em' }}>
        <button onClick={()=>saveItem()}>OK</button>
      </Row>
      <Row style={{ marginTop: '1em' }} >
        { fileUpLi }
      </Row>      
      <Row className="a-save-p">
          <button onClick={()=>saveItem()}>OK</button>
      </Row>
    </Container>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(AdmPhotoSerPhUpd);
